import { RestClient } from '@/api/rest-client'
import { Order } from '@/api/model/order'
import { OrderCount } from '@/api/model/order-count'
import { cloneDeep } from 'lodash'
import { Referral } from '@/api/model/referral'
import { User } from '@/api/model/user'
import { Branch } from '@/api/model/branch'

export class OrderClient extends RestClient<Order> {
    collectionName = 'orders'
    parseData = Order.fromData

    async update(id: string, data: Order): Promise<Order> {
        const request = cloneDeep<any>(data)

        request.orderValue = Number(data.orderValue)
        request.transactionValue = Number(data.transactionValue)
        request.askingPrice = Number(data.askingPrice)

        if (request.orderValue === 0) {
            request.orderValue = null
        }

        if (request.transactionValue === 0) {
            request.transactionValue = null
        }

        if (request.askingPrice === 0) {
            request.askingPrice = null
        }

        if (data.referral instanceof Referral) {
            request.referral = data.referral.resourceIdentifier
        }

        if (data.assignedTo instanceof User) {
            request.assignedTo = data.assignedTo.resourceIdentifier
        }

        if (data.assignedToBranch instanceof Branch) {
            request.assignedToBranch = data.assignedToBranch.resourceIdentifier
        }

        if (data.involvedUsers) {
            request.involvedUsers = data.involvedUsers.map(user => {
                return user instanceof User ? user.resourceIdentifier : user
            })
        }

        request.orderValueShares = data.orderValueShares.map(share => {
            return {
                ...share,
                orderValue: share.orderValue || 0,
                user: share.user instanceof User ? share.user.resourceIdentifier : share.user,
                branch: share.branch instanceof Branch ? share.branch.resourceIdentifier : share.branch,
                order: data.resourceIdentifier,
            }
        })

        return super.update(id, request)
    }

    async getOrderCountForType(type: string|string[], params: object): Promise<OrderCount> {
        try {
            const response = await this.client.post(`${this.basePath}/${this.collectionName}/counts/list`, {
                type,
            }, {
                params,
            })
            return response.data

        } catch (error) {
            this.handleError(error)
        }
    }
}
